// Display helpers for the staff wallet view. Amounts arrive from the API as integer cents.
import { format, parseISO } from 'date-fns';

// The wallet stays off until settlement and commission go live; set per deployment, matching
// WALLET_ENABLED on afto_api.
export const IS_WALLET_ENABLED = process.env.NEXT_PUBLIC_WALLET_ENABLED === 'true';

export const WALLET_ACTIVITY_PAGE_SIZE = 20;

// How the Customer wallets list is ordered; the API takes these values as its sort.
export const WALLET_LIST_SORTS = {
  BALANCE: 'balance',
  RECENT: 'recent',
};

export const WALLET_STATUSES = {
  ACTIVE: 'active',
  FROZEN: 'frozen',
  CLOSED: 'closed',
};

export const WALLET_STATUS_LABELS = {
  [WALLET_STATUSES.ACTIVE]: 'Active',
  [WALLET_STATUSES.FROZEN]: 'Frozen',
  [WALLET_STATUSES.CLOSED]: 'Closed',
};

export const WALLET_DIRECTIONS = {
  CREDIT: 'credit',
  DEBIT: 'debit',
};

const TRANSACTION_LABELS = {
  gift_card_claimed: 'Gift card claimed',
  store_credit_issued: 'Store credit issued',
  order_refunded_to_wallet: 'Order refunded to wallet',
  wallet_spend_captured: 'Spent on an order',
  small_balance_cashed_out: 'Small balance cashed out',
  chargeback: 'Chargeback',
  correction: 'Correction',
};

export const CORRECTION_TRANSACTION_TYPE = 'correction';

export const formatWalletAmount = (amountCents, currency = 'cad') =>
  new Intl.NumberFormat('en-CA', { style: 'currency', currency: currency.toUpperCase() }).format(amountCents / 100);

export const describeWalletTransaction = (transactionType) =>
  TRANSACTION_LABELS[transactionType] || 'Wallet update';

// The API's own message is human-readable; anything else falls back to the caller's wording.
export const walletErrorMessage = (error, fallback) => error?.response?.data?.message || fallback;

// time_local is already in the store's timezone, so it is formatted as written.
export const formatWalletTime = (createdAt) =>
  createdAt?.time_local ? format(parseISO(createdAt.time_local.slice(0, 19)), 'MMM d, yyyy h:mm a') : '';

// How a paid order's total was split between the shopper's wallet and the card, and what refunds
// gave back to the wallet (null when nothing); null when the wallet paid nothing. Amounts are
// dollars, as the order details API returns them.
export const splitOrderTenders = (orderTotal, walletPaid, walletRefunded = 0) => {
  const walletCents = Math.round(Number(walletPaid || 0) * 100);
  if (walletCents <= 0) return null;
  const cardCents = Math.max(0, Math.round(Number(orderTotal || 0) * 100) - walletCents);
  const refundedCents = Math.round(Number(walletRefunded || 0) * 100);
  return {
    walletPaid: (walletCents / 100).toFixed(2),
    cardPaid: (cardCents / 100).toFixed(2),
    walletRefunded: refundedCents > 0 ? (refundedCents / 100).toFixed(2) : null,
  };
};
